import React from "react";
import Species from "../Species";
import Breed from "../Breed";

interface PetDetails {
  name: string;
  id: string;
  pet_name?: string;
  pet_id?: string;
  pet_breed_id?: number;
  pet_species_type_id?: string;
}
interface UserDetails {
  name?: string;
  id?: string;
  user_name?: string;
  user_id?: string;
}
interface UserPetDetailsProps {
  petDetails: PetDetails | null;
  userDetails: UserDetails | null;
}

const UserPetDetailsComponent: React.FC<UserPetDetailsProps> = ({ userDetails, petDetails }) => {
  const handleVisitToUserProfile = () => {
    const userId = userDetails?.id || userDetails?.user_id;
    const petId = petDetails?.id || petDetails?.pet_id;

    if (!userId || !petId) return;
    const url = `/app/customer/profile/customer-details/appointments/${userId}/${petId}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const userName = userDetails?.name || userDetails?.user_name || "N/A";
  const petName = petDetails?.name || petDetails?.pet_name || "N/A";

  return (
    <div className="grid grid-cols-1 text-xs text-gray-700 bg-white ">
      <div className="flex gap-4 items-center py-1">
        <span className="font-medium text-black text-xs">Customer Name:</span>
        <button
          onClick={handleVisitToUserProfile}
          className="text-blue-500 hover:text-blue-700 transition-colors duration-150"
        >
          {userName}
        </button>
      </div>

      <div className="flex gap-4 items-center py-1">
        <span className="font-medium text-black text-xs">Pet Name:</span>
        <span className="capitalize">{petName}</span>
      </div>

      <div className="flex gap-4 items-center py-1">
        <span className="font-medium text-black text-xs">Species:</span>
        <Species speciesId={petDetails?.pet_species_type_id} className="text-gray-800 text-xs" />
      </div>
      <div className="flex gap-4 items-center py-1">
        <span className="font-medium text-black text-xs">Breed:</span>
        <Breed
          breedId={petDetails?.pet_breed_id}
          speciesId={petDetails?.pet_species_type_id}
          className="text-gray-800 text-xs truncate"
        />
      </div>
    </div>
  );
};

export default React.memo(UserPetDetailsComponent);
